import { render, staticRenderFns } from "./pembatalan_tunggal.vue?vue&type=template&id=2d6345b2&"
import script from "./pembatalan_tunggal.vue?vue&type=script&lang=js&"
export * from "./pembatalan_tunggal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports